import React from 'react';

const TONES = {
  success: {
    ring: 'bg-emerald-500/12 border-emerald-500/25 text-emerald-300',
    halo: 'bg-emerald-500/20',
    path: <path d="M20 6L9 17l-5-5" />,
  },
  error: {
    ring: 'bg-red-500/12 border-red-500/25 text-red-300',
    halo: 'bg-red-500/20',
    path: <path d="M18 6L6 18M6 6l12 12" />,
  },
};

/**
 * Nagy állapotikon az eredmény-képernyők tetején (megerősítés sikeres / lejárt link).
 */
export default function ResultIcon({ tone = 'success', className = 'mb-6' }) {
  const t = TONES[tone] || TONES.success;

  return (
    <div className={`flex justify-center ${className}`}>
      <span className="relative">
        <span className={`absolute -inset-3 rounded-full blur-xl ${t.halo}`} />
        <span className={`relative w-14 h-14 rounded-2xl border flex items-center justify-center ${t.ring}`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
               strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
            {t.path}
          </svg>
        </span>
      </span>
    </div>
  );
}
